export default __webpack_public_path__ + "70ee713433ae417fe5a9a5c6a9841453.png";